export default {"src":"/_next/static/media/arrow-mobile.b718371f.svg","height":146,"width":93,"blurWidth":0,"blurHeight":0};